import React from 'react'

import {
  AnimatedGameTileFallback,
  AnimatedTextFallback,
} from '../../atoms/animatedFallbacks'
import {
  StyledFallbackOuterWrapper,
  StyledFallbackInnerWrapper,
} from './styles'

const GamesCarouselFallback = () => {
  const numOfGames = 6

  return (
    <StyledFallbackOuterWrapper>
      <StyledFallbackInnerWrapper>
        {Array.apply(null, Array(numOfGames)).map((_, i) => (
          <div key={`game-${i}`}>
            <AnimatedGameTileFallback />

            <AnimatedTextFallback />
            <AnimatedTextFallback level={4} />
          </div>
        ))}
      </StyledFallbackInnerWrapper>
    </StyledFallbackOuterWrapper>
  )
}

export { GamesCarouselFallback }
